import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiUpdateRisk, type UpdateRiskPatch } from '../api/risks.api';

export function useUpdateRisk(projectId: string) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: ({ riskId, patch }: { riskId: string; patch: UpdateRiskPatch }) =>
            apiUpdateRisk(projectId, riskId, patch),
        onSuccess: async () => {
            await qc.invalidateQueries({ queryKey: ['risks', projectId] });
        },
    });
}
